<div class="orders">
	@if (widget()?.assetClass === assetClassEnum.US_EQUITY) {
		<app-orders-stocks [widget]="widget()" />
	} @else {
		<app-orders-options [widget]="widget()" />
	}
</div>
